var React = require('react');

function FiltersInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"filters.inline"),React.createElement("path",{"d":"M12,3a3,3,0,0,1,.5,6V21h-1V9A3,3,0,0,1,12,3ZM5,3V9A3,3,0,0,1,5,15v6H4V15A3,3,0,0,1,4,9V3ZM20,3V13A3,3,0,0,1,20,19v2H19V19A3,3,0,0,1,19,13V3Zm-.5,11a2,2,0,1,0,2,2A2,2,0,0,0,19.5,14Zm-15-4a2,2,0,1,0,2,2A2,2,0,0,0,4.5,10ZM12,4a2,2,0,1,0,2,2A2,2,0,0,0,12,4Z","key":1})]);
}

FiltersInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = FiltersInline;

FiltersInline.default = FiltersInline;
